<template>
  <div class="container-fluid py-4">
    <div class="mb-4">
      <h4 class="mb-0">Inpatient Dashboard</h4>
      <p class="text-muted">Monitor inpatient KPIs and activity summaries</p>
    </div>

    <!-- Metric Cards -->
    <div class="row mb-4">
      <div class="col-md-2 mb-3" v-for="card in metrics" :key="card.title">
        <div class="card text-center hoverable" @click="navigateTo(card.title)">
          <div class="card-body">
            <h6 class="text-muted">{{ card.title }}</h6>
            <h3>{{ card.value }}</h3>
          </div>
        </div>
      </div>
    </div>

    <!-- Charts Row -->
    <div class="row">
      <!-- Admissions & Discharges -->
      <div class="col-md-6 mb-4">
        <div class="card h-100">
          <div class="card-header">Admissions & Discharges (Past 7 Days)</div>
          <div class="card-body" style="height: 40vh">
            <canvas id="admissionsChart"></canvas>
          </div>
        </div>
      </div>

      <!-- Bed Occupancy Trend -->
      <div class="col-md-3 mb-4">
        <div class="card h-100">
          <div class="card-header">Bed Occupancy Trend</div>
          <div class="card-body" style="height: 20vh">
            <canvas id="occupancyTrendChart"></canvas>
          </div>
        </div>

        <!-- Common Diagnoses -->
      </div>

      <div class="col-md-3 mb-4">
        <div class="card h-100">
          <div class="card-header">Common Diagnoses</div>
          <div class="card-body" style="height: 20vh">
            <canvas id="diagnosisChart"></canvas>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js/auto";

export default {
  name: "InpatientLandingPage",
  data() {
    return {
      metrics: [
        { title: "Current Inpatients", value: 85 },
        { title: "Waiting bed assignment", value: 85 },
        { title: "Admissions Today", value: 12 },
        { title: "Discharges Today", value: 9 },
        { title: "Available Beds", value: 15 },
        { title: "Bed Occupancy Rate (%)", value: "85%" },
      ],
    };
  },
  methods: {
    navigateTo(title) {
      alert(`Navigate to detailed page for ${title}`);
    },
    renderCharts() {
      // Admissions & Discharges
      new Chart(document.getElementById("admissionsChart"), {
        type: "bar",
        data: {
          labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
          datasets: [
            {
              label: "Admissions",
              data: [10, 12, 8, 9, 11, 7, 6],
              backgroundColor: "#4caf50",
            },
            {
              label: "Discharges",
              data: [8, 9, 7, 10, 6, 5, 4],
              backgroundColor: "#f44336",
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
        },
      });

      // Bed Occupancy Trend
      new Chart(document.getElementById("occupancyTrendChart"), {
        type: "line",
        data: {
          labels: ["7d ago", "6d", "5d", "4d", "3d", "2d", "Today"],
          datasets: [
            {
              label: "Occupancy %",
              data: [80, 83, 78, 85, 88, 86, 85],
              borderColor: "#2196f3",
              fill: false,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
        },
      });

      // Common Diagnoses
      new Chart(document.getElementById("diagnosisChart"), {
        type: "pie",
        data: {
          labels: ["Pneumonia", "Heart Failure", "Malaria", "Others"],
          datasets: [
            {
              data: [30, 25, 20, 25],
              backgroundColor: ["#ff9800", "#4caf50", "#2196f3", "#9c27b0"],
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: "bottom",
            },
          },
        },
      });
    },
  },
  mounted() {
    this.renderCharts();
  },
};
</script>

<style scoped>
.hoverable {
  cursor: pointer;
  transition: box-shadow 0.3s ease;
}
.hoverable:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  background-color: rgba(247, 202, 202, 0.5);
}
</style>
